import Vue from 'vue';
import store from "../store";

Vue.mixin({
  methods: {
    isObjectEmpty (someObject = {}) {
      return !(Object.keys(someObject).length);
    },
    camelize (str) {
      return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        if (+match === 0) return '';
        return index === 0 ? match.toLowerCase() : match.toUpperCase();
      });
    },
    parseToken (token = '') {
      return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
    },
    getSessionId() {
      return sessionStorage.getItem('sessionId') ? sessionStorage.getItem('sessionId') : this.setSessionId();
    },
    setSessionId() {
      const length = 5;
      let sid = Math.random().toString(36).substring(2, length+2);
      sessionStorage.setItem('sessionId', sid);
      return sid;
    },
    saveStatisticData(sid = null, fields = {}) {
      return this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/savePRStatisticData', {
        sid: sid,
        fields: fields
      });
    },
    getDataByPatientNumber () {
      const token = this.parseToken(sessionStorage.getItem('patientApiToken'));
      return this.$axios('/Patient/GetPatientByPatientNumber', {
        method: 'GET',
        params: {
          patientNumber: token.patient_number
        }
      }).then((response) => {
        if (response.data.isSuccess) {
          store.dispatch('setPatientData', response.data.data);
        }
      });
    },
    getStates() {
      return this.$axios('/State/GetAllStates', {
        method: 'GET'
      });
    },
    getPatientRelationships() {
      return this.$axios('/Patient/GetPatientEmergencyContactRelations', {
        method: 'GET'
      });
    },
    updateStepsData(pid = null, steps = {}) {
      return this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/updatePreRegStepsData',{
        pid: pid,
        steps: steps
      });
    },
    updateUserAppData(pid = null, fields = {}) {
      return this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/updateUserAppData', {
        pid: pid,
        fields: fields
      })
    },
    updatePatientInfoData(data = {}) {
      return this.$axios('/Patient/UpdatePatientInfo', {
        method: 'PUT',
        data: data
      })
    },
    setMessage(msg = '', type = 'error') {
      return this.$message({
        showClose: true,
        message: msg,
        type: type,
      });
    },
    isObjEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    setProgressBar() {
      this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/prPagesData').then((response) => {
        if (response.data.data) {
          let index = 0,
              data = response.data.data,
              ratio = (100/data.length).toFixed(2),
              header =  document.getElementsByTagName('header')[0],
              path = this.$route.path.substring(1).split('/')[1];

          path = !path ? data[0] : path;
          if (process.env.VUE_APP_SERVICE_TYPE == 'H') {
            header = document.getElementsByClassName('main-header')[0];
          }

          data.forEach((item, key) => {
            if (item == path) {
              index = key + 1; return;
            }
          });
          header.style.setProperty('--progress', (index * ratio) +'%');
        }
      });
    },
    noContact(value) {
      this.$el.querySelectorAll('.required-field').forEach(item => {
        if (value) {
          item.classList.add('hide-error')
        } else {
          item.classList.remove('hide-error')
        }
      });
    },
    goToMainPage() {
      window.location.href = window.location.origin;
    },
    capitalized(name = false) {
      if (!name) return false;
      return name[0].toUpperCase() + name.slice(1);
    },
    goBack(routerName, statFieldName){
      this.saveStatisticData(this.getSessionId(), {
        [statFieldName + '_back']: 'true'
      });
      this.$router.push({name: routerName})
    },
    setRules(fields) {
      fields.forEach((item) => {
        this.$set(this.rules, item, {
          required: true,
          message: this.$t('common.rules.valid', { field: this.$t('common.labels.' + item) }),
          trigger: 'blur'
        });
      });
    },
    setImageRules(fields) {
      fields.forEach((item) => {
        this.$set(this.rules, item + 'Side', {
          required: true,
          message: this.$t('common.rules.emptyPhoto', { side: this.capitalized(this.$t('common.labels.side.' + item +'.name')) }),
          trigger: 'change'
        });
      });
    },
    changeField(data) {
      this.saveStatisticData(this.getSessionId(), data);
    },
    saveApiLoggingData(data = {}) {
      return this.$axios.post(process.env.VUE_APP_INTERNAL_API + '/api/saveApiLoggingData',{
        data: data
      });
    },
    formattedDate(data) {
      const date = new Date(data);
      return date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      });
    }
  }
});
